import { observable, computed, action } from "mobx"; //set
import { store } from "../mainStore";
import { setTimeout } from "timers";

const dieFaceValue = [7,3,11,5,14,9,14,4,8,20,6,7,5,12,10,2,8,13,12,10,13,4,9,2,14,3,9,6,4,11,2,3,8,6,20,12,12,7,9,13,10,5,11,6,5,14,3,4,13,11,8,10,7,2];

var c = 3; //1;
var d = 2;
var h = 1; //3;
var s = 4;
var w = 0; // wild is all suits

const dieFaceSuit = [s,h,d,d,c,c,h,s,d,w,c,h,h,d,h,d,c,s,h,c,d,c,s,s,s,c,d,s,d,h,c,d,s,h,w,c,s,c,h,c,d,s,s,d,c,d,s,h,h,c,h,s,d,h];


export class Hand{
	constructor(hand, network){
		var Selection = [];
		var DiceRoll = [];
		var lastRoll = {};

		console.log('HAND constr :: h =', hand)
		if(hand && hand.Rolls?.length){
			lastRoll = hand.Rolls[hand.Rolls.length - 1];
			DiceRoll = lastRoll.DiceRoll;
			Selection = lastRoll.Selection; //hand.Rolls[hand.Rolls.length - 2]
			this.lastCombination = lastRoll.BestHandTarget;
			this.diceFaces = lastRoll.DiceFaces;
		}

		var faces = [];
		dieFaceValue.forEach((value, i) => {
			faces.push([value, dieFaceSuit[i]]);
			if(faces.length === 6){
				this.dice.push({
					faces: faces,
					held: Selection.indexOf(this.dice.length) > -1,
					showing: DiceRoll[this.dice.length],
				})
				faces = [];
			}
		});

		if(!network) { 	Object.assign(this, hand)}

		if(hand && network){
			this.best = lastRoll.BestPossibleHand || false;
			this.bonusPointsIncluded = lastRoll.ScoreBonusPointsIncluded || false;

			this.match = lastRoll.BestHand || false;
			this.rollsRemaining = 3 + hand.FreeRollsUsed - hand.Rolls.length;
			this.rollsRemaining = this.rollsRemaining > 0 ? this.rollsRemaining : 0;
			this.rolled = hand.Rolls.length > 0;
			this.complete = hand.State === 'co';
			this.rollNumber = hand.Rolls.length;
			this.score = hand.Score;
			this.finalScore = hand.FinalScore;
			this.bestHandTarget = hand.BestHandTarget;
			this.isWinner = (hand.Outcome === 1 || hand.Outcome === 3);
		}
	}

	@observable bestHandTarget = 0;
	@observable handStrength = 0;

	@observable dice = [];

	@observable rolling = false;
	@observable rolled = false;

	@observable rollsRemaining = 3;
	@observable rollNumber= 0;

	@observable best = false;
	@observable match = [];

	@observable complete = false;

	@observable score = 0;
	@observable finalScore = 0;

	@observable isWinner = false;

	@computed get isWinningHand() {
		return (this.match && this.match.length > 2);
	}

	@computed get heldIndexes(){
		var held = [];
		this.dice.forEach((d, i)=>{
			if(d.held){
				held.push(i);
			}
		});
		return held;
	}

	@computed get byValue(){
		return this.dice.map(d=>d.faces[d.showing][0]);
	}

	@computed get heldDiceCount(){
		return this.dice.filter(d => d.held).length;
	}

	@action roll(){
		if(this.complete){
			throw new Error('Attempt to roll a completed Hand. Dice can not be changed.');
		}
		return store.rollDice(this.heldIndexes)
		.then(response => {
			if(response && response.ErrorCode === 300019){
				setTimeout(() => {this.roll();},1000);
			}
		})
		.catch((err) => {
			let txt = 'hand.roll catch error:'+err;
			console.log(txt);
			// store.debug = txt + ' '+ store.debug;
		});
	}

	@action hold(index){
		var nextState = !this.dice[index].held;

		//validation
		if(store.activeMatch.currentHand.rollsRemaining < 1 || store.activeMatch.currentHand.best)
			return;

		this.dice[index].held = nextState;
		return this.dice[index];
	}

	@action nextRoll(){
		this.rollsRemaining -= 1;
		this.rollNumber += 1;
		this.rolled = true;
	}

	@action updateFromNetwork(hand){
		this.complete = hand.State === 'co';
		this.score = hand.Score;
		this.finalScore = hand.FinalScore;
		this.isWinner = (hand.Outcome === 1 || hand.Outcome === 3);
		this.handStrength = hand.HandStrength !== undefined ? hand.HandStrength : 0;
	}
}
